"use client";

import imageHpLocationMap from "@/assets/images/screens/homepage/location-map.jpg";
import imageHpLocationMapOverlay from "@/assets/images/screens/homepage/location-map.svg";
import imageHpLocationMapDesktop from "@/assets/images/screens/homepage/location-map-desktop.jpg";
import imageHpLocationMapDesktopOverlay from "@/assets/images/screens/homepage/location-map-desktop.svg";
import Image from "next/image";
import { ZoomInOnScroll } from "@/components/effects/ZoomInOnScroll";

export default function LocationMap() {
  return (
    <ZoomInOnScroll
      className="mx-auto max-w-screen-lg lg:mb-24"
      id={"location-map"}
    >
      <div className={"relative"}>
        <div className="relative z-10 overflow-hidden lg:hidden">
          <Image src={imageHpLocationMap} alt={""} className="w-full" />
        </div>
        <div className="relative z-10 hidden overflow-hidden rounded-lg lg:block">
          <Image src={imageHpLocationMapDesktop} alt={""} className="w-full" />
        </div>
        <div className="absolute inset-0 z-20 overflow-hidden lg:hidden">
          <Image src={imageHpLocationMapOverlay} alt={""} className="w-full" />
        </div>
        <div className="absolute inset-0 z-30 hidden overflow-hidden rounded-lg lg:block">
          <Image
            src={imageHpLocationMapDesktopOverlay}
            alt={""}
            className="w-full"
          />
        </div>
      </div>
    </ZoomInOnScroll>
  );
}
